import delegate from 'delegate';
import { component } from 'picoapp';

class FooterNavigation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    delegate(this, '.Nav__link.level-1', 'click', (e) => {
      e.preventDefault();
    });
    // let header = this.querySelector('.header');
    // header?.addEventListener('click', () => this.setAttribute('open', Number(this.getAttribute('open')) ? 0 : 1));
  }
}

export default component((node, ctx) => {
  if (!customElements.get('footer-navigation')) {
    customElements.define('footer-navigation', FooterNavigation);
  }
});
